import { render } from "./SliderImg.vue?vue&type=template&id=10cae151"
import script from "./SliderImg.vue?vue&type=script&lang=js"
export * from "./SliderImg.vue?vue&type=script&lang=js"

import "./SliderImg.vue?vue&type=style&index=0&id=10cae151&lang=css"

import exportComponent from "/builds/furore-dev/front-fincas-agrogo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__